"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageCTALinks = exports.CTA_SECURITY = exports.CTA_MOBILE = exports.CTA_SEO = exports.CTA_PERFORMANCE = exports.CTA_BOTTOM_BANNER_LINK = exports.CTA_OVERALL_BANNER_LINK = exports.MON109_CMS_DTT_LINK = void 0;
var MON109_CMS_DTT_LINK = 'https://app.hubspot.com/signup/trial-signup?intent=trial&trialId=7&hubs_cta=wsg-trial'; // These all have specific marketing tracking on them, specific to what buttons
// and links use them.

exports.MON109_CMS_DTT_LINK = MON109_CMS_DTT_LINK;
var CTA_OVERALL_BANNER_LINK = 'https://academy.hubspot.com/courses/web-optimization?hubs_cta=top-cta';
exports.CTA_OVERALL_BANNER_LINK = CTA_OVERALL_BANNER_LINK;
var CTA_BOTTOM_BANNER_LINK = 'https://academy.hubspot.com/courses/web-optimization?hubs_cta=bottom-cta';
exports.CTA_BOTTOM_BANNER_LINK = CTA_BOTTOM_BANNER_LINK;
var CTA_PERFORMANCE = 'https://academy.hubspot.com/lessons/improving-website-performance?hubs_cta=performance-cta';
exports.CTA_PERFORMANCE = CTA_PERFORMANCE;
var CTA_SEO = 'https://academy.hubspot.com/lessons/enhancing-seo-for-a-website?hubs_cta=seo-cta';
exports.CTA_SEO = CTA_SEO;
var CTA_MOBILE = 'https://academy.hubspot.com/lessons/optimizing-a-wesbite-for-mobile?hubs_cta=mobile-cta';
exports.CTA_MOBILE = CTA_MOBILE;
var CTA_SECURITY = 'https://academy.hubspot.com/lessons/implementing-website-security-best-practices?hubs_cta=security-cta';
exports.CTA_SECURITY = CTA_SECURITY;
var LanguageCTALinks = {
  fr: 'https://offers.hubspot.fr/optimisation-site-web?hubs_cta=fr-CTA',
  de: 'https://offers.hubspot.de/website-optimierung?hubs_cta=de-CTA',
  pt: 'https://br.hubspot.com/ofertas/otimizacao-de-pagina?hubs_cta=br-CTA',
  ja: 'https://offers.hubspot.jp/website-optimization-guide?hubs_cta=jp-CTA',
  es: 'https://offers.hubspot.es/optimizacion-web?hubs_cta=es-CTA'
};
exports.LanguageCTALinks = LanguageCTALinks;


//////////////////
// WEBPACK FOOTER
// ./js/constants/TrialConstants.js
// module id = 36
// module chunks = 0